import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "pcl" }
const _hoisted_2 = {
  key: 0,
  class: "pcl-hint"
}
const _hoisted_3 = {
  key: 0,
  class: "pcl-empty"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "pcl-title-row" }
const _hoisted_6 = { class: "pcl-title" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "pcl-body" }
const _hoisted_9 = { class: "pcl-label" }
const _hoisted_10 = { class: "pcl-val" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.disabledHint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.disabledHint), 1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!_ctx.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.emptyText), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (it, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: idx,
              class: "pcl-card",
              onClick: ($event: any) => (_ctx.$emit('edit', it))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.resolve(_ctx.titleField, it) || '—'), 1),
                _createElementVNode("button", {
                  class: "pcl-del",
                  title: "Șterge",
                  onClick: _withModifiers(($event: any) => (_ctx.$emit('delete', it)), ["stop"])
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "dx-icon dx-icon-trash" }, null, -1)
                ]))], 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (f, fi) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: fi,
                    class: "pcl-row"
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(f.label), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.resolve(f, it) || '—'), 1)
                  ]))
                }), 128))
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "dx-icon dx-icon-chevronright pcl-arrow" }, null, -1))
            ], 8, _hoisted_4))
          }), 128)),
          _createElementVNode("button", {
            class: "pcl-fab",
            disabled: _ctx.disableAdd,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add')))
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "dx-icon dx-icon-plus" }, null, -1)
          ]))], 8, _hoisted_11)
        ], 64))
  ]))
}